import { render, staticRenderFns } from "./ClinicAgency.vue?vue&type=template&id=2a22fb1c&scoped=true&"
import script from "./ClinicAgency.vue?vue&type=script&lang=js&"
export * from "./ClinicAgency.vue?vue&type=script&lang=js&"
import style0 from "./ClinicAgency.vue?vue&type=style&index=0&id=2a22fb1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a22fb1c",
  null
  
)

export default component.exports